module.exports = __webpack_public_path__ + "static/media/fantasy.66e050a5.svg";